import React from 'react';
import "./CreatorPage.css"

function CreatorPage() {
  return (
    <div className="creator-page">
        <h1 className="creator-title">CREATOR'S CORNER</h1>
    </div>
  );
}

export default CreatorPage;
